import { PRODUCTION_ENVIRONMENT } from '@os-components';
import { authProd } from './environment-variables';

export const environment = {
    ...PRODUCTION_ENVIRONMENT,
    baseURLs: {
        ...PRODUCTION_ENVIRONMENT.baseURLs,
        href: '/blog/',
        api: {
            ...PRODUCTION_ENVIRONMENT.baseURLs.api,
            domain: '',
            mwfServlet: '/mwf_live/servlet',
        },
    },
    auth: authProd,
    preview: false,
};
